// extracted by mini-css-extract-plugin
export default {"container":"container_B9Qfp","isWebView":"isWebView_PoXo9","mainContainer":"mainContainer_Eue2N","aside":"aside_CaGeF"};